import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  UilCreateDashboard,
  UilBookAlt,
  UilCreditCard,
  UilConstructor,
  UilBell,
  UilFileEditAlt,
  UilFileUpload
} from '@iconscout/react-unicons';

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const mMenu = [
  getItem(<NavLink to="/dashboard">Dashboard</NavLink>, 'dashboard', <UilCreateDashboard />, null, 'dashboard'),
  getItem(<NavLink to="/emps">Employees</NavLink>, 'emps', <UilConstructor />, null, 'emps'),
  getItem(<NavLink to="/emp-trainings">EMP Trainings</NavLink>, 'trainings', <UilBookAlt />, null, 'trainings'),
  getItem(<NavLink to="/e-cards">EMP Cards</NavLink>, 'cards', <UilCreditCard />, null, 'cards'),
  getItem(<NavLink to="/update-reqs">Update Requests</NavLink>, 'update-reqs', <UilFileEditAlt />, null, 'update-reqs'),
  getItem(<NavLink to="/important-docs">Important Documents</NavLink>, 'important-docs', <UilFileUpload />, null, 'important-docs'),
  getItem(<NavLink to="/notifications">Notifications</NavLink>, 'notifications', <UilBell />, null, 'notifications'),
];

export default mMenu